import { useCallback, useContext, useEffect, useMemo } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTranslation } from 'react-i18next';

import BACMLogo from '~/assets/logos/bacm-logo.jpeg';
import DBSLogo from '~/assets/logos/dbs-logo.png';
import { LoadingContext } from '~/contexts/LoaderContext';
import { getLanguage, Language, languages } from '~/locales/languages';

import styles from './Header.module.scss';

export const HeaderComponent = () => {
  const { i18n } = useTranslation();
  const { startLoading, stopLoading } = useContext(LoadingContext);

  const currentLanguage: Language = useMemo(() => getLanguage(i18n.language), [i18n.language]);

  const handleLanguageChange = useCallback(
    async (lang: any) => {
      startLoading();
      await i18n.changeLanguage(lang);
      setTimeout(() => {
        stopLoading();
      }, 2000);
      // window.location.reload();
    },
    [startLoading],
  );

  useEffect(() => {}, []);

  return (
    <div className={styles['align-header']}>
      <img src={DBSLogo} alt="DBS" className={styles['dbs-logo']} />
      <div className={styles['right-content']}>
        <Dropdown>
          <Dropdown.Toggle variant="secondary" className={styles['dropdown-toggle']}>
            <img src={currentLanguage.flatIcon} alt="active language icon" /> {currentLanguage.label}
          </Dropdown.Toggle>

          <Dropdown.Menu className={styles['dropdown-menu']}>
            {languages
              .filter(l => l.label !== currentLanguage.label)
              .map(({ label, flatIcon }, index) => (
                <Dropdown.Item
                  className={styles['dropdown-item']}
                  key={index}
                  onClick={() => handleLanguageChange(label)}
                >
                  <img src={flatIcon} alt={label} /> {label}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
        <div className={styles.divider}></div>
        {/* <img src={BACMLogo} alt="BACM" className={styles['bacm-logo']} /> */}
        <img src={BACMLogo} alt="BACM" style={{ objectFit: 'contain', height: 40, width: 80 }} />
      </div>
    </div>
  );
};
